import { Box, Typography } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import errorImage from './icons/errorImage.svg';
import { ContinueShopping } from './ContinueShopping';

interface ErrorObject {
  response?: {
    status?: number;
  };
  isRetryable?: boolean;
}

export const isErrorObj = (error: unknown): error is ErrorObject => {
  return (
    typeof error === 'object' &&
    error !== null &&
    ('response' in error || 'data' in error)
  );
};

// A map of error status to i18n errorMessages Translation Group keys.
const errorMap = {
  401: {
    errorMessageDetailsKey: 'unauthorizedToViewOrderErrorDetails',
  },
  404: {
    errorMessageDetailsKey: 'orderNotFoundErrorDetails',
  },
  default: {
    errorMessageDetailsKey: 'defaultErrorDetails',
  },
};

interface ErrorHandlerProps {
  error: unknown;
}

export const ErrorHandler = ({ error }: ErrorHandlerProps) => {
  const status = isErrorObj(error) ? error.response?.status : undefined;
  const [errorMessages = {}] = useTranslations(['errorMessages']);

  let errorDisplayMessage =
    errorMessages[errorMap.default.errorMessageDetailsKey];
  if (status && errorMap[status as keyof typeof errorMap]) {
    errorDisplayMessage =
      errorMessages[
        errorMap[status as keyof typeof errorMap].errorMessageDetailsKey
      ];
  }

  return (
    <Box mb={7} mt={{ xs: 7, sm: 9 }}>
      <img src={errorImage} alt="" />
      <Typography my={5}>{errorDisplayMessage}</Typography>
      <ContinueShopping />
    </Box>
  );
};
